<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Currency Rates</span>
        </nav>

        <div class="block-content">
            <div class="table-responsive">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Base Currency</th>
                            <th>Second Currency</th>
                            <th>Second Currency Symbol</th>
                            <th>Exchange Rate</th>
                            <th>Last Update</th>
                            <th>Update Exchange Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(rate, index) in rates"
                            :key="rate.id"
                            class="text-center"
                        >
                            <td>{{ index + 1 }}</td>
                            <td>USD</td>
                            <td>{{ rate.name }}</td>
                            <td>{{ rate.symbol }}</td>
                            <td>{{ rate.rates }}</td>
                            <td>{{ rate.updated_at }}</td>
                            <td class="text-center">
                                <button
                                    @click.prevent="rateModal(rate)"
                                    type="button"
                                    class="btn btn-success"
                                >
                                    Update
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div
            class="modal fade"
            id="modal-rates"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fadein"
            style="display: none;"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3
                            class="card-title text-muted h4"
                            v-if="current_rate"
                        >
                            Update Rate for {{ current_rate.name }} ({{
                                current_rate.symbol
                            }})
                        </h3>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Beginning of the form -->
                    <form @submit.prevent="updateRate">
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="name">Rate</label>
                                        <input
                                            v-model="new_rate"
                                            type="text"
                                            class="form-control"
                                            id="name"
                                            required
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        class="btn btn-lg btn-outline-info mb-2"
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            new_rate: "",
            rates: [],
            current_rate: undefined
        };
    },
    methods: {
        rateModal(rate) {
            this.current_rate = rate;
            $("#modal-rates").modal("show");
        },
        async updateRate() {
            let data = {
                rates: this.new_rate
            };
            try {
                await UsersRepository.updateRate(this.current_rate.id, data);
                toast.fire({
                    type: "success",
                    title: "Rate updated successfully"
                });
                $("#modal-rates").modal("hide");
                this.loadRates();
            } catch (error) {
                if (error.response.status == 403) {
                    toast.fire({
                        type: "error",
                        title: "Action Unauthorized"
                    });
                }
            }
        },
        loadRates() {
            UsersRepository.viewRates().then(response => {
                this.rates = response.data;
            });
        }
    },
    created() {
        this.loadRates();
    }
};
</script>
